import { print } from 'graphql'

import { storefrontClient } from '..'
import { LogoutCustomerDocument, type LogoutCustomerMutation } from '../__generated/storefront'

export const logoutCustomer =
  () =>
  async (token: string): Promise<boolean> => {
    const response = await storefrontClient.request<LogoutCustomerMutation>(
      print(LogoutCustomerDocument),
      {
        variables: {
          customerAccessToken: token,
        },
      },
    )

    const payload = response.data?.customerAccessTokenDelete

    if (!payload?.deletedAccessToken) {
      throw new Error('Failed to logout customer')
    }

    return true
  }
